import React, { Component, useEffect } from "react";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import { useMutation } from "@apollo/client";

import { LayoutSplashScreen } from "../../../../_metronic/layout";
import * as actions from "../../../Pages/Assets/_redux/assetActions";
import { LOCAL_STORAGE_ROLES, TOKEN } from "../../../Utils/constant";
import { HOME_PAGE } from "../../../Utils/routePaths";
import * as auth from "../_redux/authRedux";
import { SIGNOUT } from "../mutations";

export function BeforeLogout({ logout }) {
  const history = useHistory();

  const dispatch = useDispatch();

  const [signOut] = useMutation(SIGNOUT, {
    fetchPolicy: "no-cache",
    onCompleted() {
      logout();
      window.localStorage.removeItem("user");
      localStorage.removeItem("user");
      window.localStorage.removeItem(LOCAL_STORAGE_ROLES);
      window.localStorage.removeItem(TOKEN);
      window.localStorage.removeItem("currentUser");
      window.localStorage.removeItem("authToken");
      window.localStorage.removeItem("permissions");
      history.push(HOME_PAGE);
    },
    onError() {
      logout();
      window.localStorage.removeItem("user");
      localStorage.removeItem("user");
      window.localStorage.removeItem(LOCAL_STORAGE_ROLES);
      window.localStorage.removeItem(TOKEN);
      window.localStorage.removeItem("currentUser");
      window.localStorage.removeItem("authToken");
      window.localStorage.removeItem("permissions");
      history.push(HOME_PAGE);
    },
  });

  useEffect(() => {
    if (window.localStorage.getItem(TOKEN)) {
      signOut();
    } else {
      window.location.replace("/");
    }
  }, []);

  useEffect(() => {
    dispatch(
      actions.setAccessData({
        button: false,
        addUser: false,
        chatWindow: false,
        chatList: false,
      }),
    );

    dispatch(actions.setLastBid(null));
    dispatch(actions.setIsAcceptedStatus(false));
    dispatch(actions.setAssetinWishList(null));
    dispatch(actions.setIsCancelledOffer(false));
    dispatch(actions.setIsDeclineOffer(false));
    dispatch(actions.bidlist({ count: 0, tempArr: [] }));
  }, [dispatch]);

  return <LayoutSplashScreen />;
}

class Logout extends Component {
  componentDidMount() {}

  render() {
    const { hasAuthToken } = this.props;

    return hasAuthToken ? (
      <BeforeLogout logout={this.props.logout} />
    ) : (
      <BeforeLogout logout={this.props.logout} />
    );
  }
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken) }),
  auth.actions,
)(Logout);
